import {DialogContent, Typography} from '@mui/material';
import {BaseDialog, BaseList} from '@resurs-internal/mui';
import {IconBadge} from 'components';
import {useDialog, useTranslate} from 'hooks';

export const InvoiceProcessDialog = () => {
  const dialog = useDialog('invoice-process-info');
  const translate = useTranslate();

  const list = [
    {
      icon: <IconBadge type={'font'} icon={'paper-plane'} />,
      id: '1',
      title: translate('payment.invoice-process.step-one.title'),
      subtitle: translate('payment.invoice-process.step-one.subtitle'),
    },
    {
      icon: <IconBadge type={'font'} icon={'calendar-day'} />,
      id: '2',
      title: translate('payment.invoice-process.step-two.title'),
      subtitle: translate('payment.invoice-process.step-two.subtitle'),
    },
    {
      icon: <IconBadge type={'font'} icon={'wallet'} />,
      id: '3',
      title: translate('payment.invoice-process.step-three.title'),
      subtitle: translate('payment.invoice-process.step-three.subtitle'),
    },
  ];
  return (
    <BaseDialog maxWidth={'sm'} open={dialog.open} onClose={dialog.onClose}>
      <DialogContent sx={{paddingX: {xs: 0, md: 4}, paddingBottom: {md: 4}}}>
        <Typography
          mb={4}
          variant="h6"
          sx={{textAlign: {xs: 'center', md: 'start'}}}>
          {translate('payment.invoice-process.title')}
        </Typography>
        <Typography mb={4} textAlign="center" variant="h1">
          {translate('payment.invoice-process.dialog.title')}
        </Typography>
        <BaseList
          sx={{
            '.MuiListItem-root': {paddingBottom: 4, borderBottomStyle: 'none'},
          }}
          items={list}
        />
      </DialogContent>
    </BaseDialog>
  );
};
